import { render, staticRenderFns } from "./iconPhone.vue?vue&type=template&id=6f82ddb6&scoped=true"
import script from "./iconPhone.vue?vue&type=script&lang=js"
export * from "./iconPhone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f82ddb6",
  null
  
)

export default component.exports